import { Box } from '@mui/material';
import AssetItemDetails from './AssetDetails';
import AssetItemChart from './AssetChart';
import type { DeviceStats } from 'types/utilization.types';
import useAppTheme from 'hooks/useAppTheme';
import { CLIENT_THEME, clientThemePalette } from 'utils/clientTheme';

const _palette = clientThemePalette[CLIENT_THEME];

interface Props {
  data: DeviceStats;
  selectedSource: string[];
  utilizationType: string;
  getSourceLabel?: (source: string) => string;
}

const AssetItem = ({
  data,
  selectedSource,
  utilizationType,
  getSourceLabel,
}: Props) => {
  const { enableDarkTheme } = useAppTheme();
  const palette = enableDarkTheme ? _palette.dark : _palette.light;

  return (
    <Box
      sx={{
        backgroundColor: enableDarkTheme
          ? palette.paperBackground
          : palette.toolBarBackground,
        border: `1px solid ${palette.borderGrey}`,
        padding: '16px',
        borderRadius: '8px',
        marginBottom: '10px',
      }}
      data-attribute="assetItemBox"
    >
      <AssetItemDetails data={data} utilizationType={utilizationType} />
      <AssetItemChart
        selectedSource={selectedSource}
        data={data}
        getSourceLabel={getSourceLabel}
      />
    </Box>
  );
};

export default AssetItem;
